import {createFileRoute} from '@tanstack/react-router';

import MedicationRequestPdf from '@/shared/views/medicationRequest/MedicationRequestPdf';

export const Route = createFileRoute('/(shared)/medication-requests/$medicationRequestId/pdf')({
  component: () => MedicationRequestPdf,
  loader: ({params}) => ({
    medicationRequestId: params.medicationRequestId
  })
});
